module.exports = __webpack_public_path__ + "static/media/030-news.a5290cce.svg";